import { PostMediaFile } from "shared/types/post";

import { MediaPicker } from "./media-picker";

export function MediaForm(props: {
  onSelect(files: PostMediaFile[]): Promise<void>;
  limit: number;
  onClose(): void;
  selectedAccountIds: string[];
}) {
  return <MediaPicker {...props} />;
}
